<template>
  <v-row>
    <v-card class="mx-auto" width="100%" height="490">
      <v-card-title>
        <a
          v-for="(header, index) in headers"
          :key="index"
          class="text-subtitle-1 font primary--text mt-n6"
        >
          {{ header.title }}
        </a>
        <v-spacer></v-spacer>
        <v-text-field
          v-model="search"
          append-icon="mdi-magnify"
          label="Buscar"
          single-line
          hide-details
        ></v-text-field>
      </v-card-title>

      <v-data-table
        :headers="headers"
        :items="dataCrud"
        :search="search"
        :page.sync="page"
        :items-per-page="itemsPerPage"
        :sort-by="['clinicalHistories_hcp']"
        :sort-desc="[true]"
        hide-default-footer
        class="elevation-1"
        @page-count="pageCount = $event"
        @click:row="clickTo"
      >
        <template v-slot:item[`index`]="{ index }">
          {{ index + 1 }}
        </template>
        <template v-slot:[`item.actions`]="{ item }">
          <div v-if="item.permission_HCP !== '🔒 Sin acceso'" class="d-flex align-center">
            <div 
              class="d-flex align-center mr-5"
              style="cursor: pointer"
              @click="summaryHCP(item)"
            >
              <v-icon class="mr-1">mdi-clipboard-text-outline</v-icon>
              <span class="text-caption ml-n1">Reporte</span>
            </div>
            <div 
              class="d-flex align-center"
              style="cursor: pointer"
              @click="exportHCP(item)"
            >
              <v-icon class="mr-1">mdi-file-export-outline</v-icon>
              <span class="text-caption ml-n1">Exportar</span>
            </div>
          </div>
        </template>
      </v-data-table>

      <div class="d-flex justify-space-between">
        <v-pagination v-model="page" :length="pageCount"></v-pagination>
      </div>

      <div>
        <v-dialogs-pat-c
          :headersHCPvsTest="headersHCPvsTest"
          :dataHCPvsTest="dataHCPvsTest"
          :cloneHCP="cloneHCP"
          :createHCP="createHCP"
          :selected.sync="localSelected"
          :checkboxFormEmpty.sync="localCheckboxFormEmpty"
          :handleEventsbox="handleEventsbox"
          :transfer="transfer"
          :codeTransferInput="codeTransferInput"
          :assimilate="assimilate"
          :assimilateNPatNoCount.sync="assimilateNPatNoCountLocal"
          :assimilateNPatVerif.sync="assimilateNPatVerifLocal"
          @update:selected="updateSelected"
        />
      </div>
    </v-card>
  </v-row>
</template>

<script>
import VDialogsPatC from '@/components/base/VDialogsPatC.vue';

export default {
  name: 'VTableProPatientRecords',
  components: {
    VDialogsPatC,
  },
  props: [
    'headers',
    'dataCrud',
    'headersHCPvsTest',
    'dataHCPvsTest',
    'cloneHCP',
    'summaryHCP',
    'exportHCP',
    'clickTo',
    'createHCP',
    'selected',
    'checkboxFormEmpty',
    'handleEventsbox',
    'transfer',
    'codeTransferInput',
    'assimilate',
    'assimilateNPatNoCount',
    'assimilateNPatVerif',
  ],

  data() {
    return {
      search: '',
      page: 1,
      pageCount: 0,
      itemsPerPage: 5,
      localCheckboxFormEmpty: false,
      localSelected: this.selected ? [...this.selected] : [],
    };
  },

  watch: {
    // Cuando el Padre cambia el prop, actualizamos lo local SOLO si es distinto
    selected(newVal) {
      // Comparamos el contenido para no actualizar si son iguales
      if (JSON.stringify(newVal) !== JSON.stringify(this.localSelected)) {
        this.localSelected = newVal ? [...newVal] : [];
      }
    },

    // Cuando el Padre cambia el checkbox (ej. desde handleEventsbox)
    checkboxFormEmpty(newVal) {
      if (newVal !== this.localCheckboxFormEmpty) {
        this.localCheckboxFormEmpty = newVal;
      }
    },

    // Cuando el Diálogo cambia el valor local, avisamos al Padre
    localSelected(val) {
      this.$emit('update:selected', val);
    },

    localCheckboxFormEmpty(val) {
      this.$emit('update:checkboxFormEmpty', val);
    }
  },

  computed: {
    assimilateNPatNoCountLocal: {
      get() {
        return this.assimilateNPatNoCount;
      },
      set(value) {
        this.$emit('update:assimilateNPatNoCount', value);
      },
    },

    assimilateNPatVerifLocal: {
      get() {
        return this.assimilateNPatVerif;
      },
      set(value) {
        this.$emit('update:assimilateNPatVerif', value);
      },
    }
  },

  methods: {
    updateCheckboxFormEmpty(val) {
      this.localCheckboxFormEmpty = val;
      this.$emit('update:checkboxFormEmpty', val);
    },

    updateSelected(val) {
      this.localSelected = val;
      this.$emit('update:selected', val);
    }
  },
};
</script>
